import _                                                 from 'underscore';
import React, { FC, MutableRefObject, useRef, useState } from 'react';
import { Container, Header }                             from 'semantic-ui-react';
import { QueryResult }                                   from '@apollo/react-common';

import { CorvalUIColor, CorvalUtilHexColors, FlexAlign, Size, UseStateHookFunction, Uuid } from '../../../../../types';

import { useCurrentUser, }            from '../../../../../hooks';
import { Flexbox, FlexItem, Page }    from '../../../../containers';
import { CorvalStylizedHexContainer } from '../../../../components/product/CorvalStylizedHexContainer';
import { UserPilotIdentifier }        from '../../../../components/util/external/UserPilotIdentifier';
import { PageMeta }                   from '../../../../containers/PageMeta';
import { MessageInRotatingHex }       from '../../../../components/util/messaging/MessageInRotatingHex';
import { ProjectListFocusedItem }     from './ProjectListFocusedItem';
import { ProjectList }                from './ProjectList';
import { IntercomIdentifier } from '../../../../components/util/external/IntercomIdentifier';

interface ProjectListContextType {
	focusedProjectId?: Uuid,
	setFocusedProjectId: UseStateHookFunction<Uuid>,
	projectListRequestRef: MutableRefObject<QueryResult>,
}

export const ProjectListContext = React.createContext<ProjectListContextType>( null )

const ProjectListIndexPage: FC = () => {
	
	let { currentUser }                           = useCurrentUser(),
	    [ focusedProjectId, setFocusedProjectId ] = useState<Uuid>( null ),
	    projectListRequestRef                     = useRef<QueryResult>();
	
	return (
		
		<Page name={ 'app-projects-listing' } ignoreDisplaySettings={ true } showToggleMode={ false }>
			
			<PageMeta title={ 'Project Listing' }>
				
				<CorvalStylizedHexContainer
					inverted
					fill={ 'area' }
					fadeColor={ CorvalUtilHexColors.DARK_BLUE }
					bgColor={ CorvalUIColor.DARKBLUE }
					padding={ [ Size.LG, Size.MD ] }>
					
					<ProjectListContext.Provider value={ {
						focusedProjectId,
						setFocusedProjectId,
						projectListRequestRef,
					} }>
						
						<Container>
							
							<Flexbox cols={ 2 } gutterSize={ Size.LG } align={ FlexAlign.START }>
								
								{/* PROJECTS LIST */ }
								<FlexItem>
									
									<Header as={ 'h1' } inverted>Projects</Header>
									
									{ currentUser && (
										<ProjectList/>
									) }
								
								
								</FlexItem>
								
								{/* PROJECT FOCUS */ }
								<FlexItem className={ 'position--sticky position--top' }>
									
									{ focusedProjectId ? (
										
										<ProjectListFocusedItem/>
									
									) : (
										
										  <MessageInRotatingHex>
											  <Header textAlign={ 'center' } as={ 'h3' } content={ 'Choose a Project' } inverted/>
											  <p className={ 'text--colored-white text-center text--xs' }>Select a project on the list. If you don't see any listed, you may need to be added to one before continuing</p>
										  </MessageInRotatingHex>
									  )
									}
								
								</FlexItem>
							</Flexbox>
						
						</Container>
					
					</ProjectListContext.Provider>
				
				</CorvalStylizedHexContainer>
			
			</PageMeta>
			
			<IntercomIdentifier />
		
		</Page>
	
	)
}

export default ProjectListIndexPage;
